import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "pdf-card-adsib-information"
}
const _hoisted_2 = { class: "text" }
const _hoisted_3 = { class: "text" }
const _hoisted_4 = { class: "text" }
const _hoisted_5 = {
  key: 1,
  class: "pdf-card-adsib-error"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_ctx.adsibInformation)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _cache[0] || (_cache[0] = _createElementVNode("span", { class: "text-bold" }, " Estado: ", -1)),
          _createTextVNode(" " + _toDisplayString(_ctx.adsibInformation.solicitud.estado), 1)
        ]),
        _createElementVNode("div", _hoisted_3, [
          _cache[1] || (_cache[1] = _createElementVNode("span", { class: "text-bold" }, " Vigencia: ", -1)),
          _createTextVNode(" " + _toDisplayString(_ctx.DateTime.fromISO(_ctx.adsibInformation.contrato.fechaInicio).toFormat(
          _ctx.DATE_FORMAT_HUMAN
        )) + " - " + _toDisplayString(_ctx.DateTime.fromISO(_ctx.adsibInformation.contrato.fechaFin).toFormat(
          _ctx.DATE_FORMAT_HUMAN
        )), 1)
        ]),
        _createElementVNode("div", _hoisted_4, [
          _cache[2] || (_cache[2] = _createElementVNode("span", { class: "text-bold" }, " Firma: ", -1)),
          _createTextVNode(" " + _toDisplayString(_ctx.adsibInformation.token.estado ? "HABILITADO" : "INHABILITADO"), 1)
        ])
      ]))
    : (_openBlock(), _createElementBlock("div", _hoisted_5, _cache[3] || (_cache[3] = [
        _createElementVNode("div", { class: "text" }, [
          _createElementVNode("span", { class: "text-warning" }, " USTED NO PUEDE FIRMAR, solicitar a Recursos Humanos. ")
        ], -1)
      ])))
}